/**
  * @ngdoc component
  * @name common.component:itxStoreLocatorActionButtons
  *  
  * @param {object} store Selected store
  *
  * @description
  * Store locator action buttons displayed in the tunnel pop up.s
  * Only for Desktop and tunnel
  * 
  * @param {object} store Selected store object
  * @param {boolean} action Action button allowed
  * @param {Array} checkEstafeta If estafeta mail this param will be filled.
  * 
*/
(function () {

    'use strict';

    var itxStoreLocatorActionButtonsCmp = {
        bindings: {
            store: '<',
            action:'<',
            checkEstafeta: '<',
            onSelectStore: '&'
        },
        controller: itxStoreLocatorActionButtonsCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'store-locator-action-buttons.component.html'
    };

    itxStoreLocatorActionButtonsCmpCtrl.$inject = [
        '$rootScope',
        'ItxStoreLocatorSvc', 
        'ItxScreenSizeSvc',
        'imLocatorService',
        'ngDialog',
        'ItxTranslateSvc'
    ];

    function itxStoreLocatorActionButtonsCmpCtrl (
        $rootScope, 
        ItxStoreLocatorSvc, 
        ItxScreenSizeSvc,
        imLocatorService,
        ngDialog,
        ItxTranslateSvc
    ){
        var _this = this;
        _this.showHighVolumeText=false;

        _this.$onInit = function () {
            _this.text = ItxStoreLocatorSvc.getTranslations();

            _this.isTunnel = inditex.iPage === 'ItxCheckoutPage';

            _this.isDesktop = ItxScreenSizeSvc.is('md,lg');
        };
        /**
         * @ngdoc method
         * @name onChanges
         * @methodOf common.component:itxStoreLocatorActionButtons
         * @description
         * Show high volume message when the max quantity of items has been reached and the store cannot receive more
         * packages to pickup.
         */
        _this.$onChanges=function(){
            _this.showHighVolumeText =!_this.isDroppointSearch() &&
                                _this.store && 
                                (!_this.store.isPickupAllowed || _this.store.isBlocked);
        };
        _this.doAction = function (store) {
            
            // IMAnalytics evento seleccionar_tienda
            imLocatorService.selectStore(store, _this.imIsDropPoint);

            var isEstafeta = null;

            if (!_this.checkEstafeta) {
                _this.confirmStore(store);
                return;
            }

            isEstafeta = _.some(_this.checkEstafeta, function (estafeta) {
                return estafeta === store.id;
            });
            if (isEstafeta) {
                ngDialog.open({
                    template: '<itx-dialog-message title="ngDialogData.title" message="ngDialogData.message" on-continue="ngDialogData.onContinue()" close-dialog="closeThisDialog()"></itx-dialog-message>',
                    className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ngdialog-message',
                    showClose: true,
                    plain: true,
                    data: {
                        title: '',
                        message: ItxTranslateSvc.translateCms('legacy.orderShippingPage_estafeta'),
                        onContinue: function () {
                            ngDialog.close();
                            _this.confirmStore(store);
                        }
                    }
                });
            } else {
                _this.confirmStore(store);
            }
        };

        _this.confirmStore = function (selectedStore) {
            _this.onSelectStore({ store: selectedStore });
            $rootScope.$broadcast(_this.action, selectedStore);
        };

        _this.isDroppointSearch = function () {
            return ItxStoreLocatorSvc.isDroppointSearch();
        };

    }

    angular.module('itxApp.common')
        .component('itxStoreLocatorActionButtons', itxStoreLocatorActionButtonsCmp);

})(window.itxApp);
